import { createSlice } from "@reduxjs/toolkit";
interface ILoadingSlice {
    count: number;
}

const initialState: ILoadingSlice = {
    count: 0,
};

const LoadingSlice = createSlice({
    name: "loading",
    initialState,
    reducers: {
        startLoading: (state) => {
            state.count += 1;
        },
        endLoading: (state) => {
            if (state.count > 0) state.count -= 1;
        },
        resetLoading: (state) => {
            state.count = 0;
        }
    },
});

export const { startLoading, endLoading, resetLoading } = LoadingSlice.actions;
export const selectLoading = (state: any) => state.loading.count > 0;
export const selectLoadingCount = (state: any) => state.loading.count;

export default LoadingSlice.reducer;



